export default {
  have_account: 'Har du en konto?',
  sign_in: 'Log ind',
  sign_in_description: 'for at bruge dine point og gemte oplysninger',
  join_free: 'Tilmeld dig gratis',
  join_description: '– optjen belønninger på hver ordre',
  join_description_with_discount: `– optjen belønninger som op til <highlight>{{max_discount}} rabat</highlight> på hver ordre`,
  join_description_with_product_and_discount: `– optjen belønninger som gratis {{product_name}} og op til <highlight>{{max_discount}} rabat</highlight> på hver ordre`,
  demo_mode: 'Demotilstand',
};
